/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShippingTime
 */
export interface ShippingTime {
    /**
     * 
     * @type {string}
     * @memberof ShippingTime
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingTime
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingTime
     */
    rangeStart: string;
    /**
     * 
     * @type {string}
     * @memberof ShippingTime
     */
    rangeEnd: string;
}

/**
 * Check if a given object implements the ShippingTime interface.
 */
export function instanceOfShippingTime(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "rangeStart" in value;
    isInstance = isInstance && "rangeEnd" in value;

    return isInstance;
}

export function ShippingTimeFromJSON(json: any): ShippingTime {
    return ShippingTimeFromJSONTyped(json, false);
}

export function ShippingTimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShippingTime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'rangeStart': json['range_start'],
        'rangeEnd': json['range_end'],
    };
}

export function ShippingTimeToJSON(value?: ShippingTime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'range_start': value.rangeStart,
        'range_end': value.rangeEnd,
    };
}

